import { AttributeClient } from '@frontend/attribute/api';
import { Attribute } from '@frontend/attribute/types';
import { EntityType } from '@frontend/common';
import { defaultCellClassName } from '@frontend/components/list';
import { ReactiveObjectList } from '@frontend/components/list-v2';
import { CommonMessage } from '@frontend/lang';
import { ModalType } from '@frontend/modal';

import { usePlatformModalHost } from '../../../modal/platform-modal-host/platform-modal-host.context';
import { ApplicationContainer } from '../../application-container/application-container';
import OverviewHeader from '../../header/overview-header';
import { useAttributes } from './attributes.controller';
import { CreateAttributeModal } from './create-attribute-modal/create-attribute-modal.component';

export const Attributes = () => {
    const viewProps = useAttributes();
    const { openPlatformDetail } = usePlatformModalHost();
    return (
        <ApplicationContainer>
            <OverviewHeader
                title={
                    <div className='flex gap-2'>
                        <span>{CommonMessage.OBJECTS.CATALOG.DEFAULT}</span>
                        <span>/</span>
                        <span>{CommonMessage.OBJECTS.ATTRIBUTE.PLURAL}</span>
                    </div>
                }
                create={{
                    onCreate: () =>
                        viewProps.openModal(
                            viewProps.createAttributeModalId,
                            () => <CreateAttributeModal />,
                            {},
                            { type: ModalType.PANE, className: 'max-w-[600px]' }
                        ),
                    entity: EntityType.ATTRIBUTE
                }}
            />
            <ReactiveObjectList<Attribute>
                fetch={(arg) => AttributeClient.fetchAttributes(arg)}
                columns={{
                    columns: ['name', 'values'],
                    headerOverwrite: new Map([['name', CommonMessage.OBJECTS.ATTRIBUTE.ATTRIBUTE_NAME]]),
                    customCells: new Map([
                        [
                            'values',
                            (obj) => (
                                <td className={`${defaultCellClassName} flex gap-2.5`}>
                                    {obj.row.original.values.map((value) => (
                                        <div
                                            key={value}
                                            className='bg-border-default inline-flex h-6 min-w-6 items-center justify-center rounded px-1'>
                                            <div className='text-foreground-default justify-start text-sm font-medium'>{value}</div>
                                        </div>
                                    ))}
                                </td>
                            )
                        ]
                    ])
                }}
                activeFilter={{ searchKeys: ['name'], displayName: new Map([['name', CommonMessage.OBJECTS.ATTRIBUTE.ATTRIBUTE_NAME]]) }}
                dispatch={viewProps.dispatch}
                type={EntityType.ATTRIBUTE}
                eventListener={EntityType.ATTRIBUTE}
                onSelectElement={(obj) => openPlatformDetail({ entityType: EntityType.ATTRIBUTE, id: obj.id })}
            />
        </ApplicationContainer>
    );
};
